import {httpService} from "@/modules/common/services";
import storageService from "@/modules/common/services/storageService";
import {isPersistentCacheEnabled} from "@/modules/common/utils/persistentCache";

const VERTICALS = ["healthcare"] // Currently hard coded - with future option of getting from DB (core)

const GEO_DATA_BY_IP_TTL_MS = 60 * 60 * 1000; // 1h
const GEO_DATA_BY_IP_CACHE_KEY = 'GEO_DATA_BY_IP';

const getAccount = (params) => {
  return httpService.get("profile", params)
};

const getBusiness = () => {
  return httpService.get("profile/business")
};

const getSettings = () => {
  return httpService.get("profile/settings")
};

const getStaff = () => {
  return httpService.get("profile/staff")
};

const getGeoDataByIP = async () => {
  const useCache = isPersistentCacheEnabled();

  if (useCache) {
    const cached = storageService.getWithExpiry(GEO_DATA_BY_IP_CACHE_KEY);
    if (cached) return cached;
  }

  const geoData = await httpService.get("profile/geo_data_by_ip");
  if (useCache && geoData) storageService.saveWithExpiry(GEO_DATA_BY_IP_CACHE_KEY, geoData, GEO_DATA_BY_IP_TTL_MS);

  return geoData;
};

const checkVerticalExistance = (businessVertical) =>{
  return VERTICALS.includes(businessVertical)
}

export default {
  getAccount,
  getBusiness,
  getStaff,
  getSettings,
  getGeoDataByIP,
  checkVerticalExistance

}

